/**
 * Burma Slideshow : mini fade slideshow vanilla.
 *
 * Pourquoi pas Flickity Pipeline ? Pipeline init Flickity sans cellSelector,
 * donc Flickity aspire TOUS les enfants directs du wrapper comme cellules,
 * y compris nos boutons prev/next. Et window.Flickity n'est pas exposé en
 * global donc on ne peut pas binder externalement à l'instance.
 *
 * Cette version maison gère :
 * - Fade transition entre slides via classes is-active
 * - Boutons prev/next cliquables (cherchés dans la section, pas le wrapper)
 * - Autoplay optionnel avec pause au hover
 *
 * Markup attendu :
 *   <section data-burma-slideshow data-burma-slideshow-autoplay="true|false"
 *            data-burma-slideshow-speed="4000">
 *     <div data-burma-slideshow-track>
 *       <div data-burma-slide-index="0" class="...slide is-active">...</div>
 *       <div data-burma-slide-index="1" class="...slide">...</div>
 *     </div>
 *     <button data-burma-slide-prev>...</button>
 *     <button data-burma-slide-next>...</button>
 *   </section>
 */
(function () {
  function init(section) {
    var track = section.querySelector('[data-burma-slideshow-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-burma-slide-index]');
    if (slides.length < 2) return;

    var prev = section.querySelector('[data-burma-slide-prev]');
    var next = section.querySelector('[data-burma-slide-next]');
    var autoplay = section.getAttribute('data-burma-slideshow-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-burma-slideshow-speed'), 10) || 4000;

    var current = 0;
    var timer = null;

    function go(idx) {
      var newIdx = ((idx % slides.length) + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      slides[newIdx].classList.add('is-active');
      current = newIdx;
    }

    function startAutoplay() {
      if (!autoplay || timer) return;
      timer = setInterval(function () { go(current + 1); }, speed);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) {
      prev.addEventListener('click', function () { stopAutoplay(); go(current - 1); startAutoplay(); });
    }
    if (next) {
      next.addEventListener('click', function () { stopAutoplay(); go(current + 1); startAutoplay(); });
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-burma-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
